import { Flex, Divider, Text } from "@chakra-ui/react";
import {
  permissionFor,
  FeatureAccess,
} from "@syla/shared/types/helpers/permissions";
import { AccountType } from "@syla/shared/types/models/AccountBase";
import React, { useContext } from "react";
import { SylaSampleUrls } from "../../../constants/SylaSampleUrls";
import { canUnlockPlanFeature } from "../../../helper/canUnlockPlanFeature";
import { TaxReportsContext } from "../../../pages/TaxReports";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { useGlobalVariablesStore } from "../../../store/globalVariablesStore";
import { useQueryGetAccount } from "../../../store/useQueryGetAccount";
import { ContentHeadingContainer, SectionCard } from "../../atoms/Containers";
import { SectionHeading } from "../../atoms/Headings";
import { DocumentContainer } from "./DocumentContainer";
import { TaxReportRow } from "./TaxReportRow";

export const TaxReportSummary = (): JSX.Element => {
  const selectedFinancialYear = useGlobalVariablesStore(
    (state) => state.selectedFinancialYear,
  );
  const { isLoading, subscriptions, txCount } = useContext(TaxReportsContext);

  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  // fetch user details
  const { data: account } = useQueryGetAccount(accountId);

  const { hasPermission } = permissionFor({
    feature: FeatureAccess.GetTaxReport,
    subscriptions,
    transactionCount: txCount,
    account,
  });

  const canPurchase = canUnlockPlanFeature(account);

  return (
    <SectionCard>
      <ContentHeadingContainer>
        <Flex direction="row" alignItems="center">
          <SectionHeading>Crypto Tax Report</SectionHeading>
        </Flex>
      </ContentHeadingContainer>
      <Text color="gray.600" fontSize="sm" mx="20px">
        Download your Crypto Tax Report to complete your tax return.
      </Text>
      <Divider mt="1rem" borderColor="gray.300" />

      <DocumentContainer>
        <TaxReportRow
          selectedFinancialYear={selectedFinancialYear}
          isLoading={isLoading}
          canDownload={hasPermission}
          canPurchase={canPurchase}
          sampleUrl={
            account?.accountType === AccountType.SMSF ?
              SylaSampleUrls.TaxReportSMSF
            : SylaSampleUrls.TaxReportIndividual
          }
        />
      </DocumentContainer>
    </SectionCard>
  );
};
